import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Interfaceformdata, PlanificadorService } from '../models/control.service';
import { CookieService } from 'ngx-cookie-service';
import { SseService } from 'src/app/services/SseService';
import { IndicatorTech, SelectModel, SelectModelFrec } from '../models/models.component';
import { InterfaceformdataRastreador, RastreadorService } from 'src/app/services/rastreador.service';
import { HttpClient } from '@angular/common/http';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { di } from '@fullcalendar/core/internal-common';
import { MatDialog } from '@angular/material/dialog';
import { HelpDialogComponent, HelpDialogData } from '../common/help-dialog/help-dialog.component';
import { TemaService } from 'src/app/services/tema.services';
@Component({
  selector: 'app-rastreador',
  templateUrl: './rastreador.component.html',
  styleUrl: './rastreador.component.scss'
})
export class RastreadorComponent implements OnInit {
  public texto: string = ">>"
  public mouseSobreDiv: boolean = false;
  private panelTimeout: any;
  public isDark: boolean = false;
  public modeloDiv: boolean = localStorage.getItem('rastreador_panel_modeloDiv') !== 'false';
  public cartera: boolean = localStorage.getItem('rastreador_panel_cartera') !== 'false';
  public rastreador: boolean = localStorage.getItem('rastreador_panel_rastreador') !== 'false';
  public loading: boolean = false;
  public selectedTab: number = 0;
  //  Modelformdata: Interfaceformdata;
  private formdataSubcription: Subscription;

  public token: any;
  public selectedIdMercado: any;
  public selecIdMercadoVolatilidad: any;
  public selecIdCompaniaVolatilidad: any;
  public selectedIdCompania: any;
  public selectedFrecuency: any;
  public mercadosVolatilidad: any;
  public companiasVolatilidad: any;
  public mercados: any;
  public companias: any[];
  public subFormData: Subscription;
  allIndicatorTypes: any;
  public fechaInicial: any;
  public nuevaOpcion = {
    descripcion: "Todas las compañias",
    fecha: "2024-04-24T00:00:00.000+00:00",
    idNectum: 0,
    iso: "Todas las Compañias",
    n: 0,
    precioteorico: 99.99
  };

  Modelformdata: InterfaceformdataRastreador;
  public totalactivos: 0;
  public idMercadoAnt: any;

  modelIndicator: IndicatorTech = {
    indicator1: 'Close',
    bar1: 0,
    indicator2: 'MH',
    bar2: 1,
    operator: '>',
    value: '0.1'
  }
  public indicators: string[] = [];
  indicatorsNumbers: string[] = [];
  frecuencySelect: SelectModelFrec[] = [];
  public companiasIndice: any;
  public idMercadoIndice: number;
  public idActivoIndice: number;
  public idActivoVolatilidad: number;
  public idMercadovolatilidad: number;
  public todosSelected: boolean = false;
  public bajista: boolean = false;
  public periodico: boolean = false;
  public optimalWallet: OptimalWallet;
  public asignarCapital: boolean = false;
  public repeticionEntradas: boolean = false;
  public editing: boolean = false;
  stopLoss: boolean = true;
  proFit: boolean = true;
  stopLossDinamico: boolean = true;
  profit: boolean = true;
  public stopLossValue = 20;
  public proFitValue = 20;
  public activatedModelo: boolean = false;

  isInValid: boolean = true;
  isInValidModel: boolean = false;
  operators: SelectModel[] = [
    {
      description: '>',
      value: '>'
    },
    {
      description: '=',
      value: '='
    },
    {
      description: '<',
      value: '<'
    },
    {
      description: '>=',
      value: '>='
    },
    {
      description: '<=',
      value: '<='
    },
    {
      description: '<>',
      value: '<>'
    }
  ];

  indicatorsTexts: string[] = ['Macd', 'Macd(signal)'];
  indicatorTypes: SelectModel[] = [];

  constructor(
    private _cookieService: CookieService,
    private _sseservice: SseService,
    public _rastreadorservice: RastreadorService,
    private _httclient: HttpClient,
    public planificadorsv: PlanificadorService,
    private cdr: ChangeDetectorRef, private toastr: ToastrService,
    private dialog: MatDialog,
    private temaservicio: TemaService
  ) { }

  ngOnInit(): void {
    this.temaservicio.valDarkTheme.subscribe({ next: (data: boolean) => { this.isDark = data; } });
    // Restore states from cookies
    this.restoreStatesFromCookies();

    this.token = this._cookieService.get('auth_token');
    this.planificadorsv.loadIndicatorTypes()
      .then((res: any) => {
        this.allIndicatorTypes = res.data;
        this.indicatorsNumbers = this.allIndicatorTypes.indicadores;
        this.indicators = this.allIndicatorTypes.indicadores;
        let { tiporatios, periodos } = res.data;
        // this.frecuencia.emit(periodos)
        tiporatios.forEach((el: any, index: number) => {
          this.indicatorTypes.push({ description: el, value: index + '' })
        });
      });
    this._sseservice.apiPostNew("listamercados", {}, this.token).subscribe({
      next: (data: any) => {
        console.log(data);
        this.mercados = data;
        this.mercadosVolatilidad = data;
      }
    });
    this.subFormData = this._rastreadorservice.valformdata$.subscribe({
      next: (data: any) => {
        this.Modelformdata = data;
        const hoy = new Date();
        this.Modelformdata.fechaFinString = hoy.toISOString().split('T')[0];
        this.Modelformdata.idMercado = 8; // Default market ID
        this.selectedIdMercado = this.Modelformdata.idMercado;
        this.Modelformdata.period = 6;
        this.selectedFrecuency = this.Modelformdata.period;
        
      }
    });
   
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  replaceWithIndicators(sentence: string, indicadoresIA: string[]): string {
    let words = sentence.split(' ');
    let indicatorIndex = 1;
    console.log(this.planificadorsv.indicatorsIaSinEspacios.length);
    words = words.map(word => {
      const index = this.planificadorsv.indicatorsIaSinEspacios.indexOf(word);
      if (index !== -1) { indicadoresIA.push(word) }
      return index !== -1 ? `indicador_${indicatorIndex++}` : word;
    });

    return words.join(' ');
  }
  restoreWithOriginalWords(sentence: string, wordsToReplace: string[]): string {
    let words = sentence.split('"');
    words = words.map(word => {
      if (word.startsWith('indicador')) {
        const index = parseInt(word.replace('indicador_', '')) - 1;
        return wordsToReplace[index].replaceAll('_', ' ');
      }
      return word;
    });

    return words.join('"');
  }
  calcularDiasHabiles(fechaInicio: string): number {
    const inicio = new Date(fechaInicio);
    const hoy = new Date();
    let diasHabiles = 0;

    for (let d = inicio; d <= hoy; d.setDate(d.getDate() + 1)) {
      if (d.getDay() !== 0 && d.getDay() !== 6) { // 0 es domingo, 6 es sábado
        diasHabiles++;
      }
    }

    return diasHabiles;
  }
  buscarCompania(tipo: string) {

    if (tipo == 'Activo') {
      const jsonData = {
        idmercado: this.Modelformdata.idMercado
      };
      this._sseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
        next: (data: any) => {
          this.companias = data;
          this.companias.unshift(this.nuevaOpcion);
          console.log(this.companias);
          this.selectedIdCompania = 99999;
        }
      });
    } else if (tipo == 'Volatilidad') {
      const jsonData = {
        idmercado: this.Modelformdata.idMercadoSerie
      };
      this._sseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
        next: (data: any) => {
          this.companiasVolatilidad = data;
        }
      });
    }

  }
  toggleIndice() {
    this.planificadorsv.showIndice = !this.planificadorsv.showIndice;
  }

  toggleVolatilidad() {
    this.planificadorsv.showVolatilidad = !this.planificadorsv.showVolatilidad;
  }
  cargarData() {
    console.log("COMPAÑIA SELECCIONADA VOLATILIDAD: ", this.selecIdCompaniaVolatilidad);
    this._rastreadorservice.updateIsVolati(true);
    this._rastreadorservice.updateIdNectumSeries(this.selecIdCompaniaVolatilidad.idNectum);
    let url = 'v3/historical-price-full/' + this.selecIdCompaniaVolatilidad.iso + '?from=1990-01-01';
    if (this.selecIdCompaniaVolatilidad.iso) {
      this.Modelformdata.idNectumSerie = this.selecIdCompaniaVolatilidad.idNectum;
      //  console.log("LA URL: ", url);
      this._sseservice.apiGetNew(url).subscribe({
        next: (data: any) => {
          this._rastreadorservice.updateHistoricoVol(data.historical);
          this._rastreadorservice.updateIsVolati(false);
        }
      });
    }
  }
  finishEditing(item: string[]): void {
    this.editing = false;
    console.log('eicion terminada ');
    console.log(item);
    this.loading = true;
    this.activatedModelo = true;
    // Lo editado (item[0]) pasa a ser también el original (item[2]); si no, ln queda con el
    // texto viejo en item[2] y deja de coincidir con list_conditions_entry/exit.
    this.planificadorsv.condiciones.forEach(element => element[2] = element[0]);
    this.planificadorsv.sincronizarListasCondiciones();
    this.activatedModelo = false;
    this.loading = false;
    this.planificadorsv.loadingModel = false;

    console.log(this.planificadorsv.condiciones);


  }
  registrarCompania(input: string, event: any) {
    console.log("registrar" + this.idActivoIndice);
    console.log(event);
    if (input == 'IndiceActivo') {
      this.planificadorsv.idActivoIndice = this.idActivoIndice;
      console.log(this.planificadorsv.idActivoIndice);
    }
    if (input == 'VolatilidadActivo') {
      console.log(this.planificadorsv.idActivoVolatilidad);
      this.planificadorsv.idActivoVolatilidad = this.idActivoVolatilidad;
    }
  }
  onTodosChange(event: any) {
    if (event.checked) {
      let diasHabiles = this.calcularDiasHabiles(this.Modelformdata.fechaInicio);
      if (diasHabiles < 1500) {
        this.Modelformdata.periodoModeloPeriodico = diasHabiles;
      } else {
        this.todosSelected = false;
        this.toastr.error('La fecha inicial debe ser desde 2020');
      }
    } else {
      this.Modelformdata.periodoModeloPeriodico = 0; // o cualquier valor por defecto
    }
  this.changeInput('periodoModeloPeriodico', { target: { value: this.Modelformdata.periodoModeloPeriodico } });
  }
  public actualizarcapitalinicial() {
    console.log(this.totalactivos);
    if (this.totalactivos === undefined) {
      if (this.periodico) {
        this._sseservice.apiPostNew('mercado/contarActivosporMercado', { idmercado: this.Modelformdata.idMercado }, '').toPromise().then(
          response => {
            this.totalactivos = response.total;
            if (this.totalactivos <= 10) {
              this.actualizarcapitalinicial();
            } else {
              this.toastr.error("La lista de mercados seleccionada puede tener un máximo de 10 activos.");
              this.Modelformdata.idMercado = this.idMercadoAnt;
              this.selectedIdMercado = this.idMercadoAnt;
            }
          }
        ).catch(error => {
          // this.loading = false;
        });
      }
    } else {
      let capitalInicialPrima = (this.optimalWallet.capitales[0] * this.totalactivos) + (this.optimalWallet.capitales[1] * this.totalactivos * this.Modelformdata.periodoModeloPeriodico);
      console.log(capitalInicialPrima);
      this.optimalWallet.capitalinicial = capitalInicialPrima;
    }
  }
  startEditing(item: string[]): void {
    console.log(item);
    this.editing = true;
  }
  /** true si la fecha "YYYY-MM-DD" cae en sábado o domingo (interpretada como fecha local). */
  private esFinDeSemana(fecha: string | null | undefined): boolean {
    if (!fecha) { return false; }
    const [y, m, d] = fecha.split('-').map(Number);
    if (!y || !m || !d) { return false; }
    const dia = new Date(y, m - 1, d).getDay(); // 0 = domingo, 6 = sábado
    return dia === 0 || dia === 6;
  }

  generateModel() {
    // El análisis filtra las señales por el día de la semana de la fecha inicial; si cae en
    // fin de semana no coincide con ninguna vela diaria y la corrida sale vacía.
    if (this.esFinDeSemana(this.Modelformdata.fechaInicio)) {
      this.toastr.error('La fecha inicial del análisis no puede caer en sábado ni domingo');
      return;
    }
    this.activatedModelo = true;
    //        console.log("Modelo de mercado", this.Modelformdata);
    console.log(this.Modelformdata)
    let jsonData = {
      list_conditions_entry: this.planificadorsv.interpretacionDataListEntry,
      list_conditions_exit: this.planificadorsv.interpretacionDataListExit,
      start: this.Modelformdata.fechaInicio != null ? this.Modelformdata.fechaInicio : new Date('2018-01-01').toISOString().split('T')[0],
      end: new Date().toISOString().split('T')[0],
      idnectums: [],
      stopLoss: 20,
      bajista: false,
      periodo: 6,
      idmercado: this._rastreadorservice.idMercado.value,
      sectype: 'STK',
      ln: this.planificadorsv.condiciones,
      periodoModeloPeriodico: this.Modelformdata.periodoModeloPeriodico,
      nocondiciones: this.planificadorsv.noCondiciones,
      repeticionentradas: this.repeticionEntradas,
      diasEvaluar: this.Modelformdata.diasEvaluar,
      diasHabiles: this.Modelformdata.diashabiles,
      diadesemana: this.Modelformdata.diadesemana,
      rangoPorcentualEvaluar: this.Modelformdata.rangoPorcentualEvaluar,
    };
    console.log("jsonData: ", jsonData);
    //       console.log("Modelo de mercado", this.Modelformdata);

    this._sseservice.apiGetSse('rastreador/funcionAnalisis2?data=', true, encodeURIComponent(JSON.stringify(jsonData))).subscribe(
      {
        next: (data: any) => {
          if (data.name === 'companias') {
            this._rastreadorservice.updatecompaniaAnalisis(data.data);
          } else if (data.name === 'lva') {//listavariaciones
            console.log("data name lva", data.name);
            console.log("data data lva", data.data);
            this._rastreadorservice.updatelistaVariacion(data.data);
            console.log("data total", data.data)
          } else if (data.name == 'arrayResultados') {
            console.log("data name arrayResultados", data.name);
            //  console.log("data data arrayResultados", data.data);
            this._rastreadorservice.updateArrayResultados(data.data);
          } else if (data.name === 'lvn') {//listavariacionesnegativas
            console.log("data name lvn", data.name);
            console.log("data data lvn", data.data);
            this._rastreadorservice.updatelistaVariacionNegativa(data.data);
          } else if (data.name === 'idAnalisis') {
            this._rastreadorservice.updateIdAnalisis(Number(data.data));
          } else if (data.name === 'total') {
            console.log("total ", data.name);
            console.log("data total", data.data)
          } else if (data.name === 'err') {
            this.toastr.error(data.data, "Error");
          } else if (data.name === 'info') {
            console.log("data name info", data.name);
            console.log("data data info", data.data);
            this.toastr.success(data.data, "Info");
          } else if (data.name === 'fin')
            this.activatedModelo = false;
        },
        error: (error: any) => {
          console.error('Error al generar el modelo:', error);
          this.toastr.error('Error al generar el modelo', 'Error');
          this.activatedModelo = false;
        },
      })
  }
  getFrecuency(event: any) {
    this.frecuencySelect = event;
  }
  actualizarSlideStoploss(event: any) {
    this.stopLoss = event.checked;
    this.Modelformdata.stoplossCheck = event.checked;
  }
  actualizarSlideProfit(event: any) {
    this.proFit = event.checked;
    this.Modelformdata.profitCheck = event.checked;
  }
  actualizarSlideStoplossDinamico(event: any) {
    this.stopLossDinamico = event.checked;
    this.Modelformdata.stoplossDinamicCheck = event.checked;
  }
  selectCompania() {
    console.log("this.selectedIdCompania: ", this.Modelformdata.idNectum);
    this._rastreadorservice.updateloadCompania(true);
    const jsonData = {
      idmercado: this.Modelformdata.idMercado,
      idNectum: this.Modelformdata.idNectum
    };
    console.log("jsonData: ", jsonData);
    this._sseservice.apiPostNew('mercado/buscadorCompaniasPorMercadoRastreador', jsonData, this.token).subscribe({
      next: (data: any) => {
        //console.log("ESTA ES LA DATA PA COMPANIA: ", data);
        this._rastreadorservice.updateCompaniaRastreador(data);
        this._rastreadorservice.updateloadCompania(false);
      }
    });
  }

  activatePeriod(event: any, type: number) {
    console.log("cuando se mueve el select: ", event);
    console.log(type);
    if (type == 1) {
      event.value = event.target.value;
      this.modelIndicator.indicator1 = event.value;
      console.log("es del tipo uno");
    } else {
      event.value = event.target.value;
      this.modelIndicator.indicator2 = event.value;
      console.log("entra en el dos");
    }
    // console.log(value);
    console.log(event.value);

    if (event.value == 'Numero') {
      if (type == 1) delete this.modelIndicator.period1;
      if (type == 2) delete this.modelIndicator.period2;
      return;
    }

    if (this.indicatorsNumbers.includes(event.value)) {
      if (type == 1) this.modelIndicator.period1 = { type: 'number', value: 100 }
      if (type == 2) this.modelIndicator.period2 = { type: 'number', value: 100 }
    } else if (this.indicatorsTexts.includes(event.value)) {
      if (type == 1) this.modelIndicator.period1 = { type: 'text', value: '12,26,9' }
      if (type == 2) this.modelIndicator.period2 = { type: 'text', value: '100' }
    } else {
      if (type == 1) delete this.modelIndicator.period1;
      if (type == 2) delete this.modelIndicator.period2;
    }
    console.log("Asi se inicializa la variable modelindicador.peiod1", this.modelIndicator.period1);
    console.log("Asi se inicializa la variable modelindicador.period2", this.modelIndicator.period2);
  }
  changeBar(barValue: any, bar: number) {
    if (bar === 1) this.modelIndicator.bar1 = barValue === 0 ? 1 : 0;

    if (bar === 2) this.modelIndicator.bar2 = barValue === 0 ? 1 : 0;
  }

  addCondition() {
    let conteoindicador1;
    let conteoindicador2;
    /*     if (Object.values(this.modelIndicator).includes('')) {
          this.isInValid = true;
          this.messageInvalid = 'Por favor llenar todos los campos';
          return;
        } else this.isInValid = false; this.messageInvalid = ''; */

    /* if (this.validarDuplicados(this.planificadorsv.condiciones, ['Close', 'MH'])) {
        this.isInValid = true;
        this.messageInvalid = 'Por favor llenar todos los campos';
        return;
    } else this.isInValid = false; this.messageInvalid = ''; */
    console.log("model indicador", this.modelIndicator);
    const { indicator1, bar1, indicator2, bar2, operator, value, period1, period2 } = this.modelIndicator;

    //cauntas veces aparece indicadores en las condiciones
    if (indicator1 == 'MH' || indicator1 == 'Close') {
      conteoindicador1 = 0
    } else {
      conteoindicador1 = this.Modelformdata.condicionStr.split(indicator1).length - 1;
      conteoindicador1++;
    } if (indicator2 == 'MH' || indicator2 == 'Close') {
      conteoindicador2 = 0
    } else {
      conteoindicador2 = this.Modelformdata.condicionStr.split(indicator2).length - 1;
      conteoindicador2++;
    }

    let valiPeriod1 = period1?.value != null ? '(' + period1?.value + ')' : '';
    let valiPeriod2 = period2?.value != null ? '(' + period2?.value + ')' : '';

    let secondPartCondition = indicator2 == 'Numero' ? value : `$${indicator2}${conteoindicador2}${valiPeriod2}[${bar2}]`;
    let condition = `$${indicator1}${conteoindicador1}${valiPeriod1}[${bar1}] ${operator} ${secondPartCondition}`;
    this._rastreadorservice.condiciones.push(condition);
    this.Modelformdata.condicionStr = this._rastreadorservice.condiciones.join(" && ");
    this._rastreadorservice.updateFormdata(this.Modelformdata);
    console.log("this.Modelformdata this.Modelformdata ", this.Modelformdata);
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
  }

  showTab(tab: any) {
    if (tab == 'cartera') {
      this.cartera = !this.cartera;
    } else if (tab == 'rastreador') {
      this.rastreador = !this.rastreador;
    } else {
      this.modeloDiv = !this.modeloDiv;
    }

    // Save states after any change
    this.saveStatesToCookies();
  }

  startResizing(event: MouseEvent, column: HTMLElement) {
    // Verificar si el elemento objetivo es el div deseado
    if (column.tagName === 'DIV') {
      const initialX = event.clientX;
      const initialWidth = column.offsetWidth;

      const mouseMoveListener = (mouseEvent: MouseEvent) => {
        const width = initialWidth + (mouseEvent.clientX - initialX);
        column.style.width = width + 'px';
      };

      const mouseUpListener = () => {
        document.removeEventListener('mousemove', mouseMoveListener);
        document.removeEventListener('mouseup', mouseUpListener);
      };

      document.addEventListener('mousemove', mouseMoveListener);
      document.addEventListener('mouseup', mouseUpListener);
    }
  }

  changeInput(input: string, event: any) {
    var ainput = event.target?.value || event?.value || event?.checked;
    console.log(input);
    console.log(ainput);
    console.log("EVENT: ", this.Modelformdata);
    if (input === "fechafechaComienzo") {
      let obfecha = new Date(ainput);
      let dia = obfecha.getDate();
      let mes = obfecha.getMonth() + 1;
      let year = obfecha.getFullYear();

      ainput = `${year}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;
      this.Modelformdata.fechaInicioString = ainput;
    } else if (input === 'diadesemana') {
      this.Modelformdata.diadesemana = ainput;
    }
    else if (input === 'diasEvaluar') {
      this.Modelformdata.diasEvaluar = ainput;
    } else if (input === 'rangoPorcentualEvaluar') {
      this.Modelformdata.rangoPorcentualEvaluar = ainput;
    } else if (input === 'porcentaje') {
      this.Modelformdata.porcentaje = ainput;
    } else if (input === 'porcentajeNegativo') {
      this.Modelformdata.porcentajeNegativo = ainput;
    } else if (input === 'porcentajeNegativo') {
      this.Modelformdata.porcentajeNegativo = ainput;
    } else if (input === 'repeticionEntradas') {
      this.repeticionEntradas = !!ainput;
    } else if (input === 'periodoModeloPeriodico') {
      const parsedPeriodo = Number(ainput);
      this.Modelformdata.periodoModeloPeriodico = Number.isNaN(parsedPeriodo) ? 0 : parsedPeriodo;
    } else if (input === 'period') {
      this.Modelformdata.period = event;
      this.selectedFrecuency = event;
    } else if (input === 'idMercado') {
      this.idMercadoAnt = this.Modelformdata.idMercado;
      console.log(ainput)
      // ainput ya es el idmercado numérico crudo (viene de <app-mercado-select>,
      // no del <select [ngValue]> nativo que codificaba "índice: valor" en el DOM).
      const newIdMercado = Number(ainput);
      if (!Number.isNaN(newIdMercado)) {
        console.log("newIdMercado: ", newIdMercado);
        this.Modelformdata = { ...this.Modelformdata, idMercado: newIdMercado };
        console.log(this.Modelformdata.idMercado); // Verifica que ahora sea 76
        console.log(this.Modelformdata);
        this._rastreadorservice.updateIdMercado(newIdMercado);
      }
    }
    this._rastreadorservice.updateFormdata(this.Modelformdata);
  }

  removeCondition(item: string) {
    this._rastreadorservice.condiciones = this._rastreadorservice.condiciones.filter((adata: any) => item !== adata);
    this.Modelformdata.condicionStr = this._rastreadorservice.condiciones.join(" && ");
    this._rastreadorservice.updateFormdata(this.Modelformdata);
  }
  expandirDiv() {
    if (this.panelTimeout) { clearTimeout(this.panelTimeout); this.panelTimeout = null; }
    this.texto = "<<";
    this.mouseSobreDiv = true;
  }
  contraerDiv() {
    this.panelTimeout = setTimeout(() => {
      this.texto = ">>";
      this.mouseSobreDiv = false;
    }, 200);
  }

  funcionestadisticas() {
    this.loading = true;
    console.log("Estos es model Formdata: ", this.Modelformdata);
    this._sseservice.apiGetSse('rastreador/funcionAnalisis?', true, this.Modelformdata).subscribe({
      next: (data: any) => {
        if (data.name === 'companias') {
          this._rastreadorservice.updatecompaniaAnalisis(data.data);
        } else if (data.name === 'lva') {//listavariaciones
          console.log("data name lva", data.name);
          console.log("data data lva", data.data);
          this._rastreadorservice.updatelistaVariacion(data.data);
          console.log("data total", data.data)
        } else if (data.name == 'arrayResultados') {
          console.log("data name arrayResultados", data.name);
          console.log("data data arrayResultados", data.data);
          this._rastreadorservice.updateArrayResultados(data.data);
        } else if (data.name === 'lvn') {//listavariacionesnegativas
          console.log("data name lvn", data.name);
          console.log("data data lvn", data.data);
          this._rastreadorservice.updatelistaVariacionNegativa(data.data);
        } else if (data.name === 'total') {
          console.log("total ", data.name);
          console.log("data total", data.data)
        } else if (data.name === 'err') {
          this.toastr.error(data.data, "Error");
        } else if (data.name === 'info') {
          console.log("data name info", data.name);
          console.log("data data info", data.data);
          this.toastr.success(data.data, "Info");
        }

      }, error(err) {
        console.log("hubo un error")
      }, complete: () => {
        console.log("se COMPLETO el envio de datos.");

        this.loading = false;
        this.cdr.detectChanges();


      }

    })
    // const params=new URLSearchParams(this.Modelformdata).toString();
  }

  private saveStatesToCookies(): void {
    localStorage.setItem('rastreador_panel_cartera', String(this.cartera));
    localStorage.setItem('rastreador_panel_rastreador', String(this.rastreador));
    localStorage.setItem('rastreador_panel_modeloDiv', String(this.modeloDiv));
  }

  private restoreStatesFromCookies(): void {
    // State is now read directly from localStorage at property initialization
  }

  showTabHelp(tabName: string, event: Event): void {
    event.stopPropagation();
    let helpData: HelpDialogData;

    switch (tabName) {
      case 'Estadisticas':
        helpData = {
          title: 'Estadísticas',
          items: [
            { term: 'Panel de Estadísticas', description: 'Muestra análisis estadísticos y de períodos para el rastreo de mercado.' },
            { term: 'Análisis Comparativo', description: 'Permite comparar diferentes métricas y comportamientos del mercado.' }
          ]
        };
        break;
      case 'Analisis Estadísticos':
        helpData = {
          title: 'Análisis Estadísticos',
          items: [
            { term: 'Métricas Estadísticas', description: 'Cálculos estadísticos avanzados sobre los datos del mercado.' },
            { term: 'Distribución', description: 'Análisis de la distribución de rendimientos y volatilidad.' }
          ]
        };
        break;
      case 'Analisis Periodos':
        helpData = {
          title: 'Análisis de Períodos',
          items: [
            { term: 'Segmentación Temporal', description: 'Divide el análisis en diferentes períodos de tiempo.' },
            { term: 'Comparación Histórica', description: 'Compara el rendimiento entre diferentes períodos.' }
          ]
        };
        break;
      case 'Estudio Earning':
        helpData = {
          title: 'Estudio de Earnings',
          items: [
            { term: 'Reportes de Ganancias', description: 'Análisis de los reportes de ganancias de las compañías.' },
            { term: 'Impacto en Precio', description: 'Estudia el impacto de los earnings en el precio de las acciones.' },
            { term: 'Tendencias', description: 'Identifica tendencias en los reportes de ganancias.' }
          ]
        };
        break;
      default:
        helpData = {
          title: tabName,
          items: [{ term: 'Información', description: 'Información sobre esta sección.' }]
        };
    }

    this.dialog.open(HelpDialogComponent, {
      width: '450px',
      data: helpData
    });
  }

  ngOnDestroy(): void {
    // Save states when component is destroyed
    this.saveStatesToCookies();

    // ...existing cleanup code if any...
  }
}
